import { Card, Checkbox, FormControlLabel, FormGroup, Grid, IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CreateCollectionModal from "../Modals/TriggerModal/Collections/createModal";
import DataTable from "examples/Tables/DataTable";
import { useAppServices } from "hook/services";
import EditCollectionModal from "../Modals/TriggerModal/Collections/editModal";
import { useState } from "react";

const CollectionsData = ({ app_collection, appData, handleRefresh }) => {
    const AppService = useAppServices();
    const collectionTypes = [
        { value: "user_interaction", label: "user Interaction" },
        { value: "integration", label: "Integration" },
        { value: "common_issues", label: "Common Issues" },
        { value: "general_info", label: "General Info/feedbacks" },
    ];
    const [included_all_the_apps, setIncluded_all_the_apps] = useState(false);

    const handleDelete = async (id) => {
        const payload = {
            id: id
        }

        confirm("Are you sure you want to delete this collection?") && await AppService.AppCollections.delete(payload);
        handleRefresh();
    }

    const handleCheckBox = async (id) => {
        const payload = {
            id: id,
            included_all_the_apps: !included_all_the_apps
        }
        setIncluded_all_the_apps(!included_all_the_apps);

        console.log(payload, "payload");
        await AppService.AppCollections.update({payload});
        // handleRefresh();
    }

    return (
        <>
            {collectionTypes.map((collectionType, index) => {
                const filteredCollections = app_collection.filter(col => col.type == collectionType.value);

                const tableData = {
                    columns: [
                        { Header: "Name", accessor: "name" },
                        { Header: "Type", accessor: "type" },
                        { Header: "Include collection all the apps", accessor: "included_all_the_apps" },
                        { Header: "Actions", accessor: "actions" }
                    ],
                    rows: filteredCollections.map((col) => ({
                        name: col.name,
                        type: col.type,

                        included_all_the_apps: (
                            <>
                                <MDBox>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox defaultChecked={col?.included_all_the_apps} onChange={() => handleCheckBox(col?._id)} />}
                                            label="included in all the apps"
                                            name="included_all_the_apps"
                                        />
                                    </FormGroup>
                                </MDBox>
                            </>
                        ),

                        actions: (
                            <>
                                <EditCollectionModal
                                    appData={appData}
                                    handleRefresh={handleRefresh}
                                    appCollections={app_collection}
                                    type={collectionType.value}
                                    editData={col}
                                />
                                <IconButton onClick={() => handleDelete(col._id)} color="primary">
                                    <Delete />
                                </IconButton>
                            </>
                        )
                    }))
                };

                console.log(tableData, "tableDatatableDatatableData");

                return (
                    <Grid item xs={12} key={index} gap={2}>
                        <Card className="mb-5">
                            <MDBox
                                mx={2}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    {collectionType.label}
                                </MDTypography>
                                <CreateCollectionModal
                                    appData={appData}
                                    handleRefresh={handleRefresh}
                                    appCollections={app_collection}
                                    type={collectionType.value}
                                />
                            </MDBox>
                            <MDBox pt={3} px={3}>
                                <DataTable
                                    canSearch
                                    entriesPerPage={5}
                                    table={tableData}

                                />
                            </MDBox>
                        </Card>
                    </Grid>
                );
            })}
        </>
    );
};

export default CollectionsData;